class StyleFactory {
  static createStyle(jsStyle) {
    const cssStyle = Object.entries(jsStyle)
      .map(([k, v]) => {
        const kebabKey = k.replace(
          /[A-Z]/g,
          (match) => `-${match.toLowerCase()}`
        );

        return `${kebabKey}:${v}`;
      })
      .join(';');

    return `
    <style>
    ${cssStyle}
    </style>
    `;
  }
}

export { StyleFactory };
